import {ListPrice, Price} from "../data-models/price.model";

export interface IPriceApiResponse {
  price: ListPrice;
}

export class PriceFactory {
  static createFromBackendApi(apiResponse: IPriceApiResponse): Price {
    return new Price(apiResponse.price);
  }
}
